import { Box } from "@mui/material";
import useLogisticsDetails from "hooks/useLogisticsDetails";
import Form from "./Form";

export function LogisticsDetails() {
  const props = useLogisticsDetails();
  return (
    <Box>
      <Box mt={4}>
        <Form {...props} />
      </Box>
    </Box>
  );
}
